var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1175_14572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9672 12.8994H19.6804C15.9359 12.8994 12.9004 15.9349 12.9004 19.6794V23.9662C18.8103 23.5279 23.5289 18.8094 23.9672 12.8994Z",
    fill: "#775732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 23.9662V19.6794C11.1 15.9349 8.06446 12.8994 4.31996 12.8994H0.0332031C0.471403 18.8094 5.19002 23.5279 11.1 23.9662Z",
    fill: "#775732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9672 11.1C23.5289 5.19002 18.8103 0.471404 12.9004 0.0332031V4.31996C12.9004 8.06446 15.9359 11.1 19.6804 11.1H23.9672Z",
    fill: "#775732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 0.0332031C5.19002 0.471404 0.471403 5.19002 0.0332031 11.1H4.31996C8.06446 11.1 11.1 8.06446 11.1 4.31996V0.0332031Z",
    fill: "#775732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1499 11.9998C9.8134 11.1686 11.1691 9.81291 12.0002 8.14941C12.8314 9.81291 14.187 11.1686 15.8506 11.9998C14.187 12.8309 12.8314 14.1866 12.0002 15.8501C11.1691 14.1866 9.8134 12.8309 8.1499 11.9998Z",
    fill: "#CA9352"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1175_14572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank1);
export default __webpack_public_path__ + "static/media/bank1.951b39edc27a32eacb672f33947ef250.svg";
export { ForwardRef as ReactComponent };